import { render, staticRenderFns } from "./BiosafetyCabinet.vue?vue&type=template&id=930393cc&scoped=true"
import script from "./BiosafetyCabinet.vue?vue&type=script&lang=js"
export * from "./BiosafetyCabinet.vue?vue&type=script&lang=js"
import style0 from "./BiosafetyCabinet.vue?vue&type=style&index=0&id=930393cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930393cc",
  null
  
)

export default component.exports